<template>
  <div class="upload-image">
    <input
      type="file"
      multiple
      :accept="exts.join(',')"
      ref="input"
      style="display: none"
      @change="handleChange"
    />

    <div class="upload-list">
      <div class="upload-list-item box" v-for="(url, index) in urls" :key="`file_${index}`">
        <!-- <img :src="url" alt="" /> -->
        <el-image
          style="width: 146px; height: 146px"
          :src="url"
          fit="scale-down"
          :ref="`img-${index}`"
          :preview-src-list="urls"
        ></el-image>
        <span class="upload-list__item-actions">
          <span class="upload-list__item-preview" @click="handlePictureCardPreview(index)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="upload-list__item-delete" @click="handleRemove(index)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <div
        class="box upload-list-item_loading"
        v-for="index in loading"
        :key="`loading-${index}`"
        v-loading="true"
      ></div>
      <div class="plus box" @click="handleAdd">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImage } from '@/api/upload';
import { awaitTo } from '@/utils/utils';
// import { previewImg } from './index';

export default {
  props: {
    urls: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: 0,
      exts: ['image/jpg', 'image/jpeg', 'image/png']
    };
  },
  methods: {
    async handleChange(event) {
      /**@type {File[]} */
      const files = event.target.files;
      let fails = [];
      const formData = new FormData();
      [...files].forEach(file => {
        if (!file.type.includes('image')) return fails.push(file);

        formData.append('files', file);
      });

      const validNum = files.length - fails.length;

      if (validNum !== files.length) {
        this.$message.warning('请选择图片类型');
        if (validNum === 0) return;
      }

      this.loading += validNum;

      const [err, res] = await awaitTo(uploadImage(formData));

      if (!err) {
        this.urls.push(...res.data);
      } else {
        this.$message.error('图片上传失败, 请稍后重试');
      }

      this.loading -= files.length;
      this.loading = Math.max(0, this.loading);

      event.target.value = '';
    },
    handleAdd() {
      this.$refs.input.click();
    },
    handlePictureCardPreview(index) {
      this.$refs[`img-${index}`][0].clickHandler();
      // previewImg(this.urls[index]);
    },
    handleRemove(index) {
      this.urls.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
.upload-image {
  display: flex;
  flex-wrap: wrap;

  gap: 10px;

  * {
    box-sizing: border-box;
  }

  [class^='el-icon'] {
    cursor: pointer;
  }

  .box {
    width: 146px;
    height: 146px;

    border-radius: 8px;
    overflow: hidden;
  }

  .plus {
    background-color: transparent;
    border: 1px dashed #49627c;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    .el-icon-plus {
      font-size: 42px;
      font-weight: bold;
      color: #01cad8;
    }
  }

  .plus:hover {
    border-color: #01cad8;
  }

  .upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .upload-list-item_loading {
      display: flex;
      justify-content: center;
      align-items: center;

      background: transparent;
    }

    .upload-list-item {
      position: relative;
      overflow: hidden;

      // background: #f5f7fa;

      img {
        width: inherit;
        height: inherit;
        overflow: clip;
      }

      .upload-list__item-actions {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;

        width: 100%;
        height: 100%;

        background: rgba(0, 0, 0, 0.3);
        border-radius: 8px;

        display: none;
        align-items: center;
        justify-content: center;
        gap: 15px;

        & > * {
          color: #fff;
          font-size: 20px;
        }
      }

      &:hover {
        .upload-list__item-actions {
          display: flex;

          border: 1px dashed #49627c;
        }
      }
    }
  }
}
</style>
